<div #parentDiv fxFlex="100" class="grid">
    <div *ngIf="MyDrive?.Folders.length > 0">
        <p class="item-title pt-16 pl-16 unselectable">Folders</p>
        <mat-card>
            <div
                *ngIf="dmsConfig.viewSharedDoc"
                class="dms-folder-wrapper"
                fxLayout="row wrap"
            >
                <div
                    *ngFor="
                        let folder of MyDrive?.Folders
                            | documentFilter: { Shared: true, Type: 'Folder' }
                    "
                    [fxFlex]="RowBreakPoint"
                >
                    <div class="" fxLayoutAlign="start start">
                        <app-document-folder-item
                            (click)="
                                $event.stopPropagation();
                                clickStream.next(folder)
                            "
                            (clickOutside)="
                                State.SelectedItemIds.includes(folder.ItemId)
                                    ? Actions.OnClickOutside(
                                          folder.ItemId,
                                          $event
                                      )
                                    : Actions.DoNothing()
                            "
                            [Folder]="folder"
                            [Selected]="
                                State.SelectedItemIds.includes(folder.ItemId)
                            "
                            [UserId]="UserId"
                            [dmsConfig]="dmsConfig"
                            class="document-folder bottom-rounded-corners"
                            click-outside
                            id="{{ folder.ItemId }}"
                        >
                        </app-document-folder-item>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="!dmsConfig.useMAAPPView">
                <div
                *ngIf="dmsConfig.viewMyDoc || dmsConfig.viewArchivedDoc"
                class="dms-folder-wrapper"
                fxLayout="row wrap"
                >
                <div
                    *ngFor="
                        let folder of MyDrive?.Folders
                            | documentFilter: { Shared: false, Type: 'Folder' }
                    "
                    [fxFlex]="RowBreakPoint"
                >
                    <div class="" fxLayoutAlign="start start">
                        <app-document-folder-item
                            (click)="
                                $event.stopPropagation();
                                clickStream.next(folder)
                            "
                            (clickOutside)="
                                State.SelectedItemIds.includes(folder.ItemId)
                                    ? Actions.OnClickOutside(
                                          folder.ItemId,
                                          $event
                                      )
                                    : Actions.DoNothing()
                            "
                            [Folder]="folder"
                            [Selected]="
                                State.SelectedItemIds.includes(folder.ItemId)
                            "
                            [dmsConfig]="dmsConfig"
                            [id]="folder.ItemId"
                            class="document-folder bottom-rounded-corners"
                            click-outside
                            matRipple
                        >
                        </app-document-folder-item>
                    </div>
                </div>
            </div>
            </ng-container>
            <ng-container *ngIf="dmsConfig.useMAAPPView">
                <div
                *ngIf="dmsConfig.viewMyDoc || dmsConfig.viewArchivedDoc"
                class="dms-file-wrapper-2"
                >
                <div
                    *ngFor="
                        let folder of MyDrive?.Folders
                            | documentFilter: { Shared: false, Type: 'Folder' }
                    "
                >
                    <div class="" fxLayoutAlign="start start">
                        <app-document-folder-item
                            (click)="
                                $event.stopPropagation();
                                clickStream.next(folder)
                            "
                            (clickOutside)="
                                State.SelectedItemIds.includes(folder.ItemId)
                                    ? Actions.OnClickOutside(
                                          folder.ItemId,
                                          $event
                                      )
                                    : Actions.DoNothing()
                            "
                            [Folder]="folder"
                            [Selected]="
                                State.SelectedItemIds.includes(folder.ItemId)
                            "
                            [dmsConfig]="dmsConfig"
                            [id]="folder.ItemId"
                            class="document-folder bottom-rounded-corners"
                            click-outside
                            matRipple
                        >
                        </app-document-folder-item>
                    </div>
                </div>
            </div>
            </ng-container>
            
        </mat-card>
    </div>
    <div class="pb-16" *ngIf="MyDrive?.Files.length > 0">
        <p class="item-title pt-16 pl-16 unselectable">Files</p>
        <mat-card *ngIf="MyDrive?.Files.length > 0">
            <div
                *ngIf="dmsConfig.viewSharedDoc"
                class="dms-file-wrapper"
                fxLayout="row wrap"
            >
                <div
                    *ngFor="
                        let file of MyDrive?.Files
                            | documentFilter: { Shared: true, Type: 'File' }
                    "
                    [fxFlex]="RowBreakPoint"
                >
                    <div class="" fxLayoutAlign="start start">
                        <app-document-file-item
                            (click)="
                                $event.stopPropagation(); clickStream.next(file)
                            "
                            (clickOutside)="
                                State.SelectedItemIds.includes(file.ItemId)
                                    ? Actions.OnClickOutside(
                                          file.ItemId,
                                          $event
                                      )
                                    : Actions.DoNothing()
                            "
                            [ExtMapConfig]="dmsConfig?.ExtMap"
                            [File]="file"
                            [Selected]="
                                State.SelectedItemIds.includes(file.ItemId)
                            "
                            [UserId]="UserId"
                            [State]="State"
                            [dmsConfig]="dmsConfig"
                            class="document-file text-truncate"
                            click-outside
                            matRipple
                        ></app-document-file-item>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="!dmsConfig.useMAAPPView">
                <div
                *ngIf="dmsConfig.viewMyDoc || dmsConfig.viewArchivedDoc"
                class="dms-file-wrapper"
                fxLayout="row wrap"
            >
                <div
                    *ngFor="
                        let file of MyDrive?.Files
                            | documentFilter: { Shared: false, Type: 'File' }
                    "
                    [fxFlex]="RowBreakPoint"
                >
                    <div class="" fxLayoutAlign="start start">
                        <app-document-file-item
                            (click)="
                                $event.stopPropagation(); clickStream.next(file)
                            "
                            (clickOutside)="
                                State.SelectedItemIds.includes(file.ItemId)
                                    ? Actions.OnClickOutside(
                                          file.ItemId,
                                          $event
                                      )
                                    : Actions.DoNothing()
                            "
                            [ExtMapConfig]="dmsConfig?.ExtMap"
                            [File]="file"
                            [State]="State"
                            [Selected]="
                                State.SelectedItemIds.includes(file.ItemId)
                            "
                            class="document-file text-truncate"
                            click-outside
                            matRipple
                            [dmsConfig]="dmsConfig"
                        ></app-document-file-item>
                    </div>
                </div>
            </div>
            </ng-container>
            <ng-container *ngIf="dmsConfig.useMAAPPView">
                <div
                *ngIf="dmsConfig.viewMyDoc || dmsConfig.viewArchivedDoc"
                class="dms-file-wrapper-2"

            >
                <div
                    *ngFor="
                        let file of MyDrive?.Files
                            | documentFilter: { Shared: false, Type: 'File' }
                    "
                >
                    <div class="" fxLayoutAlign="start start">
                        <app-document-file-item
                            (click)="
                                $event.stopPropagation(); clickStream.next(file)
                            "
                            (clickOutside)="
                                State.SelectedItemIds.includes(file.ItemId)
                                    ? Actions.OnClickOutside(
                                          file.ItemId,
                                          $event
                                      )
                                    : Actions.DoNothing()
                            "
                            [ExtMapConfig]="dmsConfig?.ExtMap"
                            [File]="file"
                            [State]="State"
                            [Selected]="
                                State.SelectedItemIds.includes(file.ItemId)
                            "
                            class="document-file text-truncate"
                            click-outside
                            matRipple
                            [dmsConfig]="dmsConfig"
                        ></app-document-file-item>
                    </div>
                </div>
            </div>
            </ng-container>
        </mat-card>
    </div>
</div>
